import * as React from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { Input } from "@hipotecar/ui/input";

export interface MoneyInputProps extends Omit<
	NumericFormatProps,
	"customInput" | "type"
> {
	className?: string;
}

/**
 * A wrapper around react-number-format that uses the Shadcn Input component.
 * It provides comma separation for thousands and limits decimals to 2 places.
 *
 * Usage:
 * <MoneyInput
 *   value={value}
 *   onValueChange={(values) => onChange(values.floatValue)}
 *   placeholder="0.00"
 * />
 */
export const MoneyInput = React.forwardRef<HTMLInputElement, MoneyInputProps>(
	({ className, ...props }, ref) => {
		return (
			<NumericFormat
				customInput={Input}
				getInputRef={ref}
				thousandSeparator=","
				decimalSeparator="."
				decimalScale={2}
				fixedDecimalScale
				allowNegative={false}
				type="text" // Must be text to allow commas
				className={className}
				onFocus={(e) => {
					e.target.select();
					props.onFocus?.(e);
				}}
				{...props}
			/>
		);
	},
);

MoneyInput.displayName = "MoneyInput";
